export default "__VITE_ASSET__6a0863a6__"